import useSidebarState from 'components/Sidebar/hooks/useSidebarState';
import useSidebarButtons from 'components/Sidebar/hooks/useSidebarButtons';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';

const TopBarBreadcrumbs = () => {
  const { getSelectedSidebarItemByPath } = useSidebarState();
  const { navigationButtons, buttons } = useSidebarButtons();
  const sidebarButtons = [...navigationButtons, ...buttons];
  const selected = getSelectedSidebarItemByPath(sidebarButtons);

  return (
    <Flex items='center' style={{ marginLeft: '-0.2rem' }}>
      {selected.topBarIcon && selected.topBarIcon}
      <Text color='shuttleGray' size='large' pl='0.7rem' pr='1rem' weight='600'>
        {selected.title}
      </Text>
      {selected?.badge}
    </Flex>
  );
};

export default TopBarBreadcrumbs;
